interface TripsPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Layout component specific to the Trips page that provides consistent
 * container structure across different page states (loading, error, empty, success)
 */
const TripsPageLayout: React.FC<TripsPageLayoutProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className="flex min-h-screen">
      <div
        className={`flex-1 bg-gray-50 px-4 py-8 sm:px-6 lg:px-8 ${className}`}
      >
        <div className="mx-auto max-w-7xl">{children}</div>
      </div>
    </div>
  );
};

export default TripsPageLayout;
